import React from 'react'
import _ from 'underscore'
import { ChevronDown } from 'lucide-react'
import { DropdownMenu } from '../dropdown_menu'

class SelectTemplate extends React.Component {

  onTemplateClick = (templateValue) => {
    this.props.onSelect(templateValue)
  }

  render() {
    return (
      <DropdownMenu
        buttonClassName="btn-outline btn-sm"
        className="dropdown-menu-right"
        items={this.props.templates}
        onItemClick={this.onTemplateClick}
      >
        {this.props.label || 'Template'} <ChevronDown className="size-3.5"/>
      </DropdownMenu>
    )
  }
}

export default SelectTemplate
